import { getTpaFontParamValue } from '@wix/thunderbolt-components/src/components/TPAWidget/tpaStyleUtils'
import { Component, Style } from '@wix/thunderbolt-becky-types'
import { createCompNode, themeRefs } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { isTpaComponent } from '../../../utils/is'
import { FeatureRefs } from '../../cssFeatures.types'

const stylePropertiesRegex = /^param_([^_]+)_(.*)/

const getTpaSinglePropertyFontFamilies = (
	stylePropertyKey: string,
	stylePropertyValue: string,
	themeFonts: Array<string>
) => {
	const match = stylePropertyKey.match(stylePropertiesRegex)

	const isFontStyleParam = match && match[1] === 'font' && stylePropertyValue

	if (!isFontStyleParam) {
		return null
	}

	return getTpaFontParamValue(stylePropertyValue, themeFonts)
}

export const getTpaFontFamilies = (style: Style, themeFonts: Array<string>): Array<string> => {
	const styleProperties = style.style?.properties
	if (!styleProperties) {
		return EMPTY_ARRAY
	}

	const fontFamilies: Array<string> = []
	for (const stylePropertyKey in styleProperties) {
		const value = getTpaSinglePropertyFontFamilies(stylePropertyKey, styleProperties[stylePropertyKey], themeFonts)

		if (value?.family) {
			fontFamilies.push(...value.family.split(','))
		}
	}
	return fontFamilies
}

export const tpaFontFamilies = {
	predicate: (component: Component) => isTpaComponent(component),
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => ({
			compStyles: refs.compStyles(component),
			siteFonts: themeRefs.siteFonts,
		}),
		toViewItem: (__, { compStyles, siteFonts }) => {
			if (!compStyles) {
				return EMPTY_ARRAY
			}
			const getFonts = (style: Style) => getTpaFontFamilies(style, siteFonts)
			if (compStyles.type === 'classic') {
				return Object.values(compStyles.css).flatMap(getFonts)
			}
			return Object.values(compStyles.css).flatMap((variants) => Object.values(variants).flatMap(getFonts))
		},
	}),
}
